export default __webpack_public_path__ + "static/media/never-expires-mobile.bb1c985f.svg";